import { render, staticRenderFns } from "./PartnerCard.vue?vue&type=template&id=526dc99a&scoped=true&"
import script from "./PartnerCard.vue?vue&type=script&lang=js&"
export * from "./PartnerCard.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCard.vue?vue&type=style&index=0&id=526dc99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526dc99a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
